import { DropDownList } from '@syncfusion/ej2-dropdowns';

import { IndividualRelationshipType } from '@/shared/types/enum';

import { getControl } from '@/front/editable/state';
import { listen } from '@/front/event';

listen('editablesReady', () => {
  [...document.querySelectorAll('.editable[data-field="relationshipType"]')]
    .map((editable) => editable as HTMLDivElement)
    .forEach((editable) => {
      const form = editable.closest('form') as HTMLFormElement | null;

      if (!form || form.modelName?.value !== 'Individual') {
        return;
      }

      const relationshipTypeDropDownList = getControl(editable.id) as DropDownList | undefined;
      const amlSection = form.querySelector('[data-individual-aml-section="true"]') as HTMLElement | null;
      const taxReturnSection = form.querySelector('[data-individual-tax-return-section="true"]') as HTMLElement | null;

      if (!relationshipTypeDropDownList) {
        return;
      }

      const refresh = () => {
        const isClient = relationshipTypeDropDownList.value === IndividualRelationshipType.Client;
        amlSection?.classList.toggle('d-none', !isClient);
        taxReturnSection?.classList.toggle('d-none', !isClient);
      };

      refresh();

      relationshipTypeDropDownList.addEventListener('change', refresh);
    });
});
